import { Product, ProductType, RoofOverhangProduct } from '../';

export function IsRoofOverhangProduct(product: Product): product is RoofOverhangProduct {
  return (product as RoofOverhangProduct).productType === ProductType.ROOF_OVERHANG;
}
